export const globalTheme = {
  token: {
    colorPrimary: '#046094',
    colorTextHeading: '#494E50',
    colorTextLabel: '#494E50',
    borderRadius: 0,
  },
  components: {
    Layout: {
      bodyBg: '#ffffff',
    },
    Table: {
      borderColor: '#494E50',
      headerBg: '#D9D9D9',
      headerBorderRadius: 0,
      headerSplitColor: '#494E50',
    },
    Pagination: {
      itemActiveColor: '#494E50',
    },
    Button: {
      paddingInline: '35px',
      controlHeight: 35,
      defaultBg: '#D9E7EF',
      defaultColor: '#022C43',
      defaultBorderColor: '#83AFC7',
    },
    DatePicker: {
      colorText: '#022C43',
      colorBorder: '#046094',
      colorBgContainer: '#D9E7EF',
      controlHeight: 35,
    },
    Input: {
      colorText: '#022C43',
      colorBorder: '#046094',
      colorBgContainer: '#D9E7EF',
      controlHeight: 35,
      addonBg: '#D9E7EF',
      colorPrimary: '#022C43',
    },
    Select: {
      colorText: '#022C43',
      colorBorder: '#046094',
      colorBgContainer: '#D9E7EF',
      controlHeight: 35,
      colorPrimary: '#046094',
      colorPrimaryHover: '#046094',
      optionSelectedBg: '#D9E7EF',
      optionActiveBg: '#e6f4ff',
    },
  },
};
